import { Scenario } from "../Scenario/Scenario";

export class Projection extends Scenario {
    constructor(props) {
        super(props);
        this.props = props;
    }

    isDisabledToSelect(available = []) {
        if (this.props._id != "PROGRESSAO_LINEAR") return false;
        if (available.length < 2) return true;
        return false;
    }

    getTooltipDisabled(available = []) {
        if (this.isDisabledToSelect(available))
            return "Para selecionar a Projeção Linear, é necessário possuir dados de pelo menos 2 meses.";
        return "";
    }

    setNameAndId({ _id, name }) {
        this.props._id = _id;
        this.props.name = name;
    }
}
